document.addEventListener('DOMContentLoaded', () => {
  const giftingCollectionSection = document.querySelector('.js-section-gifting-page')
  const giftingCollectionRows = giftingCollectionSection.querySelectorAll(
    '.js-collection_row_slider',
  )

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const row = entry.target
          const productCards = row.querySelectorAll('rebuilt-product-card')
          if (!productCards || productCards.length === 0) {
            return
          }
          let items = []
          productCards.forEach((productCard) => {
            const productCardDataInfo = {
              item_id: productCard.dataset.productId,
              item_name: productCard.dataset.productTitle,
              coupon: '',
              discount: productCard.dataset.productDiscount,
              index: Number(productCard.dataset.index) + 1,
              item_brand: productCard.dataset.productBrand,
              item_category: productCard.dataset.productCategory1,
              item_category2: productCard.dataset.productCategory2,
              item_category3: productCard.dataset.productCategory3,
              item_category4: '',
              item_category5: productCard.dataset.productCategory5,
              item_list_id: productCard.dataset.collectionId,
              item_list_name: productCard.dataset.collectionTitle,
              item_variant: productCard.dataset.colorPack,
              price: productCard.dataset.productPrice,
              quantity: 1,
            }
            items.push(productCardDataInfo)
          })
          const viewItemListDataObject = {
            event: 'view_item_list',
            membership_status: productCards[0].dataset.membershipStatus,
            ...window.intelligemsMeta,
            userId: productCards[0].dataset.customerId || null,
            login_status: productCards[0].dataset.loginStatus || 'non_loggedin',
            page_type: 'other',
            ecommerce: {
              item_list_id: row.dataset.collectionId,
              item_list_name: row.dataset.collectionHandle,
              currency: productCards[0].dataset.ecommerceCurrency,
              items: items,
            },
          }
          window.dataLayer = window.dataLayer || []
          dataLayer.push({ ecommerce: null })
          dataLayer.push(viewItemListDataObject)
          // Stop observing this row after the first intersection
          observer.unobserve(row)
        }
      })
    },
    {
      threshold: 0.1, // Trigger when at least 10% visible
    },
  )

  // Start observing each row
  giftingCollectionRows.forEach((row) => observer.observe(row))
})
